module.exports = __webpack_public_path__ + "static/poster1-1137056951e4826aa5fbaee608774a2a.jpg";